const style = {
  changePassword__notificationMessage: {
    marginBottom: '10px',
  },
};

export default style;
